import { Integration, Event, EventProcessor } from '@sentry/types';
import { getIssueOpenState, getMemoryInfo, IssueTracingOptions } from '../metric-common';
import { Hub } from '@sentry/core';


export const MEMORY_MONITOR_TRACING_ID = 'MemoryMonitorTracing';

// 默认tracing配置
const DEFAULT_MEMORY_MONITOR_TRACING_OPTIONS = {
  reportIssueState: true
};

/**
 * Memory Monitor
 * add memory info to current transaction
 */
export class MemoryMonitorTracing implements Integration {

  /**
   * @description 用于做global
   * @inheritDoc
   */
  public static id: string = MEMORY_MONITOR_TRACING_ID;

  public options: MemoryMonitorTracingOptions;

  /**
   * @inheritDoc
   */
  public name: string = MemoryMonitorTracing.id;

  public constructor(_options?: Partial<MemoryMonitorTracingOptions>) {
    this.options = {
      ...DEFAULT_MEMORY_MONITOR_TRACING_OPTIONS,
      ..._options
    };
  }

  /**
   * auto invoke by integrations options in Sentry.init()
   * @inheritDoc
   */
  // 这里属于eslint和typescript的配置问题，但是现存还有不少js文件，不能直接去除
  // eslint-disable-next-line no-unused-vars
  setupOnce(addGlobalEventProcessor: (callback: EventProcessor) => void, getCurrentHub: () => Hub): void {
    addGlobalEventProcessor((event: Event) => {
      const hub = getCurrentHub();
      const self = hub.getIntegration(MemoryMonitorTracing);
      if (!self) {
        return event;
      }
      return self.enhanceEventWithMemoryMonitor(event, hub);
    });
  }

  /**
   * enhance the event. if there has memory info, add span info to the sentry span
   * @param event
   * @param hub
   */
  public enhanceEventWithMemoryMonitor(event: Event, hub: Hub) {
    const memoryInfo = getMemoryInfo();
    // 如果可以采集到内存的信息，那么设置到tag中
    let { tags } = event;
    if (memoryInfo) {
      const scope = hub.getScope();
      const memoryTags = {
        'memory_jsHeapSizeLimit': memoryInfo.jsHeapSizeLimit,
        'memory_totalJSHeapSize': memoryInfo.totalJSHeapSize,
        'memory_usedJSHeapSize': memoryInfo.usedJSHeapSize
      };
      scope?.setTags(memoryTags);
      tags = {
        ...tags,
        ...memoryTags
      };
      if (this.options.reportIssueState) {
        scope?.setTag('memory:isIssueOpen', getIssueOpenState());
        tags['memory:isIssueOpen'] = getIssueOpenState();
      }
    }
    return {
      ...event,
      tags: {
        ...tags
      }
    };
  }


}

/**
 * Options for MemoryMonitorTracing integration
 */
export interface MemoryMonitorTracingOptions extends IssueTracingOptions {}
